import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasJWT, getProfile } from './helpers/hasToken';

export const PrivateRoute = ({ children }) => {
    const location = useLocation();
    const profile = getProfile();
    
    // Check if user is authenticated and has candidate role
    if (!hasJWT() || !profile || profile.role !== 'candidate') {
        // Redirect to login page with return URL
        return <Navigate to="/login/user" state={{ from: location }} replace />;
    }
    
    // User is authenticated and has candidate role, render the protected component
    return children;
};

export const AnonymousRoute = ({ children }) => {
    const location = useLocation();
    
    // If user is already authenticated, redirect to dashboard
    if (hasJWT()) {
        return <Navigate to="/candidate/dashboard" state={{ from: location }} replace />;
    }
    
    // User is not authenticated, render the public component
    return children;
};

export default PrivateRoute;